<template>
 <div class="info-box">
   <h5 class="title">{{boxTitle}}</h5>
   <h6 class="content" v-if="boxContent">{{boxContent}}
   </h6>
   <slot></slot>

 </div>
</template>

<script>
 export default {
  name: 'InfoBox',
   props: {
    boxTitle: String,
     boxContent: String
   }

 }
</script>

<style lang="scss">
@import "InfoBox.scss";
</style>
